import { render, staticRenderFns } from "./ModelLoader.vue?vue&type=template&id=cd35af3a&scoped=true"
import script from "./ModelLoader.vue?vue&type=script&lang=js"
export * from "./ModelLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd35af3a",
  null
  
)

export default component.exports